import { canv } from '@/canv/global.js'

export class shapeBubble {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - 2 * horizontalPadding;
        var allowedHeight = height - height/5 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = y + height * 4/5 / 2 - textPart.height / 2 + textPart.lines[0].textHeight;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 8;

        if (width < 6 * r) r = width / 6;
        if (height < 6 * r) r = height / 6;

        // высота выступающей части height/5
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+width, y,   x+width, y+height*4/5, r);
        canv.ctx.arcTo(x+width, y+height*4/5, x,   y+height*3/4, r);
        canv.ctx.lineTo(x+width*2/6, y+height*4/5);
        canv.ctx.lineTo(x+width/6, y+height);
        canv.ctx.lineTo(x+width/6, y+height*4/5);
        canv.ctx.arcTo(x, y + height*4/5, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+width, y,   r);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M52.9927 78.7766L36.0982 64.8524H18.1818C15.7942 64.8524 13.4298 64.3591 11.224 63.4004C9.01819 62.4418 7.01382 61.0368 5.32546 59.2655C3.6371 57.4943 2.29783 55.3915 1.38401 53.0775C0.470192 50.7634 7.62939e-06 48.283 7.62939e-06 45.7781V19.0742C7.62939e-06 16.5694 0.470192 14.089 1.38401 11.7748C2.29783 9.46062 3.6371 7.35792 5.32546 5.58673C7.01382 3.81549 9.01819 2.41052 11.224 1.45193C13.4298 0.493374 15.7942 0 18.1818 0H61.8182C66.6403 0 71.2649 2.00958 74.6747 5.58673C78.0844 9.16383 80 14.0154 80 19.0742V45.7781C80 50.837 78.0844 55.6887 74.6747 59.2655C72.9863 61.0368 70.982 62.4418 68.7761 63.4004C66.5701 64.3591 64.2059 64.8524 61.8182 64.8524V74.2827C61.8173 75.3562 61.5287 76.4075 60.9854 77.317C60.442 78.2265 59.6658 78.957 58.7454 79.4258C57.825 79.8943 56.7975 80.082 55.7803 79.9672C54.763 79.8523 53.7971 79.44 52.9927 78.7766Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7193 19.7664H13.5398L13.4013 19.8805L8.12177 24.2318L8.12163 24.2319C7.94363 24.3788 7.73242 24.4681 7.51259 24.4929C7.29294 24.5177 7.07012 24.4774 6.86887 24.375C6.66735 24.2723 6.49405 24.1106 6.37129 23.9051C6.24838 23.6994 6.18202 23.4595 6.18182 23.2129V20.2664V19.7664H5.68182C5.00473 19.7664 4.33369 19.6265 3.70677 19.3541C3.07974 19.0816 2.50843 18.6815 2.02609 18.1755L2.02607 18.1755C1.05148 17.1531 0.5 15.7615 0.5 14.3057V5.9607C0.5 4.50491 1.05147 3.11328 2.02609 2.09084L2.02609 2.09084C2.99992 1.0692 4.31546 0.5 5.68182 0.5H19.3182C19.9952 0.5 20.6663 0.639873 21.2932 0.912301C21.9202 1.18477 22.4915 1.58481 22.9739 2.09084L23.3358 1.74585L22.9739 2.09084C23.4563 2.5969 23.8401 3.19898 24.1024 3.86327C24.3648 4.52757 24.5 5.24034 24.5 5.9607V14.3057C24.5 15.026 24.3648 15.7388 24.1024 16.4031C23.8401 17.0673 23.4563 17.6694 22.9739 18.1755C22.4915 18.6815 21.9202 19.0816 21.2932 19.3541C20.6663 19.6265 19.9953 19.7664 19.3182 19.7664H13.7193Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
